import { SafariError } from '../errors/safari';

export const isSafariError = (error: Error): error is SafariError => {
  const maybeSafariError = error as SafariError;

  return (
    maybeSafariError.sourceURL !== undefined ||
    maybeSafariError.line !== undefined ||
    maybeSafariError.column !== undefined
  );
};
